export const SET_CUSTOMER = "SET_CUSTOMER"
export const FETCH_TICKET = "FETCH_TICKET"
export const CONNECT_USER = "CONNECT_USER"
export const RECEIVE_TICKET = "RECEIVE_TICKET"
export const VALIDATE_SUBDOMAIN = "VALIDATE_SUBDOMAIN"
export const CREATE_CUSTOMER = "CREATE_CUSTOMER"
export const CREATE_CUSTOMER_AVATAR = "CREATE_CUSTOMER_AVATAR"
export const RECEIVE_CREATE_CUSTOMER_SUCCESS = "RECEIVE_CREATE_CUSTOMER_SUCCESS"

export const setCustomer = (customer) => ({
  type: SET_CUSTOMER,
  customer,
})

export const createCustomerAvatar = (params, success, error) => ({
  type: CREATE_CUSTOMER_AVATAR,
  params,
  success,
  error,
})

export const connectUser = (ticketId, params, error) => ({
  type: CONNECT_USER,
  ticketId,
  params,
  error,
})

export const createCustomer = (params, success, error) => ({
  type: CREATE_CUSTOMER,
  params,
  success,
  error,
})

export const fetchTicket = (ticketId, error) => ({
  type: FETCH_TICKET,
  ticketId,
  error,
})

export const validateSubdomain = (subdomain, success, error) => ({
  type: VALIDATE_SUBDOMAIN,
  subdomain,
  success,
  error,
})

export const receiveTicket = (ticket) => ({
  type: RECEIVE_TICKET,
  ticket,
})

export const receiveCreateCustomerSuccess = () => ({
  type: RECEIVE_CREATE_CUSTOMER_SUCCESS,
})
